import React, { useEffect, useState } from 'react';
import Review from '../Review/Review';

const Reviews = () => {
    const [revieews, setReviews] = useState([]);
    useEffect(() => {
        fetch('https://infinite-river-22082.herokuapp.com/reviews')
            .then(res => res.json())
            .then(data => setReviews(data))
    }, []);
    return (
        <div className='container mt-4'>
            <h2 className='title text-center'>Check Some Reviews</h2>
            <div className='cars'>

                {
                    revieews.map(revieew => <Review
                        key={revieew._id}
                        revieew={revieew}
                    ></Review>)
                }
            </div>
        </div>
    );
};

export default Reviews;